export default {
  baseStyle: {
    track: {
      bg: 'grey.450'
    }
  },
  sizes: {
    xs: {
      track: {
        h: 1,
        borderRadius: 0
      }
    },
    sm: {
      track: {
        h: 2,
        borderRadius: 0
      }
    },
    md: {
      track: {
        h: 4,
        borderRadius: 0
      }
    },
    lg: {
      track: {
        h: 6,
        borderRadius: 0
      }
    }
  }
};